import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useState } from 'react';
import { isFirefox } from 'react-device-detect';
import { useHasSupportedVideoCodec } from '../../hooks/useHasSupportedVideoCodec';
import { useTrackBroadcastDurationEffect } from '../../hooks/useTrackBroadcastDurationEffect';
import { useWakeLock } from '../../hooks/useWakeLock';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { ViewerService } from '../../services/viewer/ViewerService';
import { useTimedFlag } from '../../utils/time';
import { useBroadcastUrl } from '../../utils/url';
import { Canvas } from '../Canvas';
import { FullscreenButton } from '../FullscreenButton';
import { ViewerViewMobileHud } from '../huds/ViewerViewMobileHud';
import { LoadingIndicator } from '../LoadingIndicator';
import { CodecNotSupported, FirefoxNotSupported } from '../NotSupportedMessage';
import { Stage } from '../Stage';
import { PluginComponentContainer } from '../shared/PluginComponentContainer';
import { PluginOverlayContainer } from '../shared/PluginOverlayContainer';
import { VideoDisplay } from '../VideoDisplay';
import { VideoOverlayDisplay } from '../VideoOverlayDisplay';
import { ViewerPreLive } from '../ViewerPreLive';
import { MobileView } from '../views/MobileView';
export function ViewerViewMobile() {
    const activeBroadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const ready = ViewerService.getOutput().useReady();
    const isVideoStreaming = ViewerService.getOutput().useIsVideoStreaming();
    useTrackBroadcastDurationEffect({
        enabled: isVideoStreaming,
        action: 'Watch',
    });
    const { requestWakeLock } = useWakeLock({ enabled: true });
    const browserVideoCodecSupported = useHasSupportedVideoCodec();
    const [isHudVisible, showHud] = useTimedFlag(true, 5000);
    const [viewElement, setViewElement] = useState(null);
    const broadcastUrl = useBroadcastUrl(activeBroadcast);
    const viewerService = ViewerService.getNotificationInterface();
    const handleCanvasMount = useCallback((canvas) => {
        if (canvas) {
            viewerService.notifyCanvasMounted(canvas);
        }
    }, [viewerService]);
    if (isFirefox) {
        return _jsx(FirefoxNotSupported, {});
    }
    if (browserVideoCodecSupported === false) {
        return _jsx(CodecNotSupported, {});
    }
    return (_jsxs(_Fragment, { children: [_jsx(LoadingIndicator, { loading: !ready }), _jsxs(MobileView, { innerRef: setViewElement, onTouchStart: () => {
                    showHud();
                }, onTouchEnd: () => {
                    // Request wake lock again when user touches the screen as
                    // there is an issue with iOS requiring user interaction to
                    // call the api.
                    // See https://developer.mozilla.org/en-US/docs/Web/Security/User_activation
                    requestWakeLock();
                }, onMouseDown: () => {
                    showHud();
                }, children: [_jsxs(Stage, { children: [_jsx(VideoDisplay, { fit: "contain", orientToScreen: true, component: _jsx(Canvas, { onCanvasMount: handleCanvasMount }) }), !isVideoStreaming && (_jsx(ViewerPreLive, { roundedCorners: false, broadcastStreamId: activeBroadcast.streamId, broadcasterUserId: activeBroadcast.broadcasterUserId }))] }), _jsxs(VideoOverlayDisplay, { fit: "contain", orientToScreen: true, children: [_jsx(ViewerViewMobileHud, { broadcastUrl: broadcastUrl, fullscreenButton: _jsx(FullscreenButton, { element: viewElement }), visible: isHudVisible }), _jsx(PluginOverlayContainer, { slotId: "overlay" }), _jsx(PluginComponentContainer, { slotId: "components" })] })] })] }));
}
